module.exports = "<div class=\"navbar\" (click)=\"perfil()\">\n    <span class=\"nome\">{{primeiroNome}}</span>\n    <img [src]=\"imagem\" alt=\"\">\n</div>"